import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next--sprite",
  "use": "next--sprite-usage",
  "viewBox": "0 0 21 34",
  "content": "<symbol viewBox=\"0 0 21 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"next--sprite\">\n<path d=\"M2.57657 31.6891L17.2656 17L2.57657 2.31095\" stroke-width=\"5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol